import { IFormInput } from "./types";

export const defaultValues: IFormInput = {
  latePaymentInterest: null,
  clientPaysOnTimeForfeits: null,
  adminLiftingCosts: null,
  againstOldersInvoices: null,
};
